import React, { createContext, useCallback, useEffect, useState } from 'react';
import { useRouter } from 'next/router';
import PropTypes from 'prop-types';

import { setPath, isSameLocation } from '@spa/shared/utils/location';
import { getLocation } from '@spa/shared/clients/core';
import { findValueAfterKey } from '@spa/shared/utils/arrays';

const LocationContext = createContext();
const LocationProvider = ({ children, location: initialLocation }) => {
  const router = useRouter();
  const { asPath, query: params } = router;
  const [pathname] = asPath.split('?');
  const [location, setLocation] = useState(initialLocation);

  const [city] = params.city || [];
  const universityQuery = findValueAfterKey(params.city, 'university');
  const neighbourhoodQuery = findValueAfterKey(params.city, 'neighbourhood');
  const transformedLocationPayload = {
    ...params,
    ...(universityQuery ? { university: universityQuery } : {}),
    ...(neighbourhoodQuery ? { neighbourhood: neighbourhoodQuery } : {}),
    city
  };

  const [locationPayload, setLocationPayload] = useState(transformedLocationPayload);
  const isResidences = pathname.includes('residences');
  const setLocationState = useCallback(
    location => {
      if (!(pathname.includes('accommodation') || isResidences)) {
        return null;
      }

      setPath(router, { ...location, pathname }, isResidences);
    },
    [router, location, pathname, isResidences]
  );

  useEffect(() => {
    const [city] = params.city || [];
    const universityQuery = findValueAfterKey(params.city, 'university');
    const neighbourhoodQuery = findValueAfterKey(params.city, 'neighbourhood');
    const transformedLocationPayload = {
      ...params,
      ...(universityQuery ? { university: universityQuery } : {}),
      ...(neighbourhoodQuery ? { neighbourhood: neighbourhoodQuery } : {}),
      city
    };

    setLocationPayload(transformedLocationPayload);
  }, [router.query]);

  useEffect(() => {
    if (!locationPayload || isSameLocation(locationPayload, location)) {
      return;
    }

    getLocation(locationPayload)
      .then(setLocation)
      .catch(console.error);
  }, [locationPayload]);

  useEffect(() => {
    if (!location || location.configuration.slug === initialLocation.configuration.slug) {
      return;
    }

    setLocationState(location);
  }, [location]);

  return <LocationContext.Provider value={[location, setLocationPayload]}>{children}</LocationContext.Provider>;
};

LocationProvider.propTypes = {
  children: PropTypes.oneOfType([PropTypes.array, PropTypes.object]).isRequired,
  location: PropTypes.object.isRequired
};

export { LocationProvider, LocationContext };
